import { Button, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { useState } from "react";
import CustomModal from '../../../core/components/ui/custom-modal.component';
import FunctionsListTable from './list-functions-table.component';
import CreateFunctionForm from './create-function-form.component';


const ModuleDetailView = ({ module, onBack }) => {
    const formattedDate = moment(module.updated_at).format('MMMM Do YYYY, h:mm:ss a');
    const [openModal, setOpenModal] = useState(null); 
    const [recordChange, setRecordChange] = useState(false)
    const [newPermission, setNewPermission] = useState(null);


    const handleOpen = (type) => {
        setOpenModal(type);
    };

    const handleClose = () => {
        setOpenModal(null);
    };

    const addPermission = (permission) => {
        console.log("New Function Added:", permission);
        setRecordChange(true); 
        setNewPermission(permission);
    };

    return (
        <div>
            <Grid container justifyContent="flex-end">
                <Button
                    variant="text"
                    startIcon={<AddBoxIcon sx={{ color: '#604CC3' }} />}
                    sx={{ textTransform: 'none' }}
                    onClick={() => handleOpen('permission')}
                >
                    Create Permission
                </Button>
            </Grid>

            <Button
                variant="text"
                startIcon={<ArrowBackIos sx={{ color: '#604CC3' }} />}
                sx={{ textTransform: 'none' }}
                onClick={onBack}
            >
                Back
            </Button>

            <Grid container spacing={2} sx={{ boxShadow: 1, borderRadius: '8px', p: 2 }}>
                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box
                        sx={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            backgroundColor: '#f5f5f5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 2,
                            padding: 1, 
                        }}
                    >
                        <Typography variant="h3" sx={{ fontSize: '1.5rem' }}>
                            {module.module_name.substring(0, 2)}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={10}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                        {module.module_name.replace(/\s+/g, '_').toUpperCase()}
                    </Typography>
                    <Typography component="div">
                        {module.description}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        Last date modified: {formattedDate}
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <FunctionsListTable 
                        recordChange={recordChange} 
                        setRecordChange={setRecordChange} 
                        module={module}
                        newPermission={newPermission}
                    />
                </Grid>
            </Grid>
            <CustomModal
                open={openModal === 'permission'}
                handleClose={handleClose}
                title="Create Permission"
            >
                 <CreateFunctionForm
                    handleClose={handleClose}
                    handleRecordChange={setRecordChange}
                    module={module}
                    addPermission={addPermission}
                />
            </CustomModal>
        </div>
    );
};

export default ModuleDetailView;